module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('van-dialog', {
    attrs: {
      "title": "用户中心",
      "show-confirm-button": false
    },
    model: {
      value: (_vm.isRegister),
      callback: function($$v) {
        _vm.isRegister = $$v
      },
      expression: "isRegister"
    }
  }, [_c('div', {
    staticClass: "form-close",
    on: {
      "click": function($event) {
        _vm.isLogin = _vm.isRegister = false
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon/close.png")
    }
  })]), _vm._v(" "), _c('van-row', {
    staticClass: "form-register"
  }, [_c('van-row', {
    staticClass: "item"
  }, [_c('van-col', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon/accout.png")
    }
  })]), _vm._v(" "), _c('van-col', {
    staticClass: "content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.userName),
      expression: "form.userName"
    }],
    attrs: {
      "placeholder": "字母开头，5-16位数字或字母"
    },
    domProps: {
      "value": (_vm.form.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "userName", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('van-row', {
    staticClass: "item"
  }, [_c('van-col', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon/password.png")
    }
  })]), _vm._v(" "), _c('van-col', {
    staticClass: "content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password),
      expression: "form.password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('van-row', {
    staticClass: "item"
  }, [_c('van-col', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon/password.png")
    }
  })]), _vm._v(" "), _c('van-col', {
    staticClass: "content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.rePassword),
      expression: "form.rePassword"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请重新输入密码"
    },
    domProps: {
      "value": (_vm.form.rePassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "rePassword", $event.target.value)
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('van-row', {
    staticClass: "form-button"
  }, [_c('van-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleConfirm(1)
      }
    }
  }, [_vm._v("立即注册")])], 1), _vm._v(" "), _c('van-row', {
    staticClass: "other-tips"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showKF),
      expression: "showKF"
    }],
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": function($event) {
        return _vm.openKF()
      }
    }
  }, [_vm._v("专属客服链接")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        return _vm.openUserDialog(1)
      }
    }
  }, [_vm._v("账号登录")])])], 1), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "用户中心",
      "show-confirm-button": false
    },
    model: {
      value: (_vm.isLogin),
      callback: function($$v) {
        _vm.isLogin = $$v
      },
      expression: "isLogin"
    }
  }, [_c('div', {
    staticClass: "form-close",
    on: {
      "click": function($event) {
        _vm.isLogin = _vm.isRegister = false
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon/close.png")
    }
  })]), _vm._v(" "), _c('van-row', {
    staticClass: "form-register"
  }, [_c('van-row', {
    staticClass: "item"
  }, [_c('van-col', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon/accout.png")
    }
  })]), _vm._v(" "), _c('van-col', {
    staticClass: "content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.userName),
      expression: "form.userName"
    }],
    attrs: {
      "placeholder": "请输入账号"
    },
    domProps: {
      "value": (_vm.form.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "userName", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('van-row', {
    staticClass: "item"
  }, [_c('van-col', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon/password.png")
    }
  })]), _vm._v(" "), _c('van-col', {
    staticClass: "content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password),
      expression: "form.password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value)
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('van-row', {
    staticClass: "form-button"
  }, [_c('van-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleConfirm(2)
      }
    }
  }, [_vm._v("立即登录")])], 1), _vm._v(" "), _c('van-row', {
    staticClass: "other-tips"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showKF),
      expression: "showKF"
    }],
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": function($event) {
        return _vm.openKF()
      }
    }
  }, [_vm._v("专属客服链接")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        return _vm.openUserDialog(2)
      }
    }
  }, [_vm._v("账号注册")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a10fa8b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingPage/UserAuth.vue
// module id = 302
// module chunks = 0 1 2 3